import { formatAsISODate } from '../../helper';

export interface DatePickerProps {
  value: string | Date | undefined;
  onChange: (dateString: string) => void;
  'aria-label'?: string;
}

export function DatePicker({
  value,
  onChange,
  'aria-label': ariaLabel,
}: DatePickerProps) {
  const dateString = formatAsISODate(value) ?? '';

  return (
    <input
      style={{
        height: '2.5rem',
        padding: '0.5em',
      }}
      type="date"
      value={dateString}
      onChange={(event) => onChange(event.target.value)}
      aria-label={ariaLabel}
    />
  );
}

export default DatePicker;
